import { useState } from 'react';
import { Alert, AlertTitle, Popover, Stack, Typography } from '@mui/material';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import ContadorPasajeros from './ContadorPasajeros';

const PasajerosSelector = ({
  adultsQuantity,
  setAdultsQuantity,
  childrenQuantity,
  setChildrenQuantity,
  babiesQuantity,
  setBabiesQuantity,
  isPackage,
  totalTourists,
  isTuristasEmpty,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'pasajeros-popover' : undefined;

  const countersConfig = [
    {
      title: 'Adultos',
      description: !isPackage ? 'desde los 12 años' : '',
      quantity: adultsQuantity,
      setQuantity: setAdultsQuantity,
      max: isPackage ? 3 : null,
    },
    {
      title: 'Niños',
      description: 'de 2 a 11 años',
      quantity: childrenQuantity,
      setQuantity: setChildrenQuantity,
      show: !isPackage,
    },
    {
      title: 'Bebes',
      description: 'menos de 2 años',
      quantity: babiesQuantity,
      setQuantity: setBabiesQuantity,
      show: !isPackage,
    },
  ];

  return (
    <>
      <div
        aria-describedby={id}
        className={`pasajeros-box-container ${isTuristasEmpty ? 'turistasqty-error' : ''}`}
        onClick={handleClick}
        role='button'
        style={{
          width: '100%',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <PersonOutlineIcon style={{ marginRight: 4, fill: '#6b7280' }} />
        <Typography color='#6b7280' style={{ marginRight: 4 }}>
          {totalTourists}
        </Typography>
        <Typography color='#6b7280'>Pasajero/s</Typography>
      </div>

      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        id={id}
        onClose={handleClose}
        open={open}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <div className='pasajeros-popup-container'>
          <Stack direction='column' spacing={2}>
            <Stack direction='row' spacing={1}>
              <PersonAddAltIcon />
              <Typography>Pasajeros</Typography>
            </Stack>

            <div className='contador-pasajeros-container'>
              {countersConfig
                .filter((counter) => counter.show === undefined || counter.show)
                .map((counter, index) => (
                  <ContadorPasajeros
                    description={counter.description}
                    key={index}
                    max={counter.max}
                    quantity={counter.quantity}
                    setQuantity={counter.setQuantity}
                    title={counter.title}
                  />
                ))}
            </div>
          </Stack>
        </div>
      </Popover>
    </>
  );
};

export default PasajerosSelector;
